var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 0.741943C3.76992 0.741943 0.125 4.38687 0.125 8.86694C0.125 13.347 3.76992 16.9919 8.25 16.9919C12.7301 16.9919 16.375 13.347 16.375 8.86694C16.375 4.38687 12.7301 0.741943 8.25 0.741943ZM6.28828 5.30522C6.7832 4.78062 7.47969 4.49194 8.25 4.49194C9.02031 4.49194 9.71055 4.78257 10.2074 5.30991C10.7109 5.84429 10.9559 6.56226 10.898 7.33413C10.7824 8.86694 9.59492 10.1169 8.25 10.1169C6.90508 10.1169 5.71523 8.86694 5.60195 7.33374C5.54453 6.55562 5.78906 5.8353 6.28828 5.30522ZM8.25 15.7419C7.33221 15.7425 6.42365 15.5589 5.57819 15.2017C4.73272 14.8446 3.96758 14.3214 3.32812 13.663C3.69436 13.1408 4.161 12.6967 4.70078 12.3568C5.69648 11.7185 6.95664 11.3669 8.25 11.3669C9.54336 11.3669 10.8035 11.7185 11.798 12.3568C12.3383 12.6965 12.8053 13.1406 13.1719 13.663C12.5325 14.3215 11.7673 14.8448 10.9219 15.2019C10.0764 15.559 9.1678 15.7426 8.25 15.7419Z",
    fill: "#01295F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.598ffcb0a8848ae808057f52b9b2e62d.svg";
export { ForwardRef as ReactComponent };